export default "__VITE_ASSET__BAQghmVc__"